import { BSBannerView } from "./BSBannerView";

export default BSBannerView;
